export default "__VITE_ASSET__DPpDqbXe__"